var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 47,
    viewBox: "0 0 161 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.8245 18.8786C78.1452 17.1863 77.1607 15.6332 75.9201 14.2967C74.7278 13.016 73.2918 11.9862 71.6963 11.2676C70.1043 10.5507 68.3775 10.1824 66.6317 10.1875C65.6422 10.1786 64.656 10.3017 63.6991 10.5536C62.9187 10.7641 62.1624 11.0553 61.4424 11.4225C60.759 11.7519 60.1203 12.1669 59.5416 12.6575V1.99728C59.5427 1.46898 59.334 0.961867 58.9614 0.587362C58.5887 0.212857 58.0827 0.00159821 57.5544 0H53.1958C52.6675 0.00159821 52.1614 0.212857 51.7888 0.587362C51.4162 0.961867 51.2075 1.46898 51.2086 1.99728V37.552C51.2086 37.9034 51.3475 38.2406 51.595 38.49C51.8425 38.7394 52.1786 38.8809 52.53 38.8836H54.3403C55.0709 38.8817 55.791 38.7099 56.4438 38.3818C57.0966 38.0536 57.6641 37.5781 58.1015 36.9929C58.1906 36.8723 58.3071 36.7746 58.4414 36.7078C58.5757 36.641 58.7239 36.607 58.8738 36.6087C59.0823 36.6057 59.2856 36.673 59.4511 36.7998C59.8701 37.1126 60.3118 37.3936 60.7726 37.6405C61.5731 38.0944 62.4209 38.4593 63.3008 38.7287C64.3845 39.0444 65.5091 39.1976 66.6377 39.1833C68.382 39.1856 70.1067 38.8153 71.6963 38.0971C73.2924 37.3851 74.7289 36.359 75.9201 35.0801C77.1638 33.7421 78.1485 32.1852 78.8245 30.4882C80.2511 26.7484 80.2511 22.6143 78.8245 18.8746V18.8786ZM65.3967 31.4757C64.5755 31.4889 63.7607 31.3282 63.0061 31.0041C62.2514 30.6799 61.5738 30.1998 61.018 29.5951C59.8212 28.342 59.2238 26.6927 59.2238 24.6854C59.2238 22.6781 59.8272 21.0287 61.0079 19.7857C61.5655 19.1799 62.2446 18.6984 63.0008 18.3726C63.757 18.0468 64.5734 17.8841 65.3967 17.895C66.2198 17.8771 67.0372 18.0367 67.7931 18.3629C68.549 18.6892 69.2258 19.1745 69.7774 19.7857C70.9722 21.0388 71.5716 22.6881 71.5716 24.6854C71.5716 26.6827 70.9681 28.342 69.7855 29.5951C69.2273 30.1995 68.5479 30.6794 67.7916 31.0035C67.0354 31.3275 66.2193 31.4885 65.3967 31.4757Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.401 12.4845V36.8903C109.397 37.4189 109.186 37.9247 108.812 38.2985C108.438 38.6723 107.932 38.8839 107.404 38.8876H103.97C103.704 38.8888 103.441 38.8363 103.195 38.7334C102.95 38.6304 102.728 38.479 102.542 38.2882C102.357 38.0974 102.212 37.8712 102.116 37.6231C102.02 37.3749 101.975 37.11 101.983 36.844C101.978 36.7562 101.94 36.6736 101.877 36.6127C101.846 36.5733 101.806 36.5414 101.762 36.5195C101.717 36.4975 101.667 36.4861 101.617 36.486C101.554 36.4829 101.492 36.5037 101.444 36.5443C100.877 36.9546 100.28 37.3223 99.6581 37.6445C98.8245 38.0925 97.9486 38.4569 97.0433 38.7327C95.9415 39.0467 94.7998 39.1985 93.6542 39.1832C92.0733 39.2045 90.5029 38.9226 89.0281 38.3526C87.6654 37.8164 86.4316 36.9979 85.4076 35.951C84.3756 34.8576 83.5782 33.5646 83.0644 32.1515C82.49 30.5495 82.2086 28.8571 82.2337 27.1553V12.4845C82.2343 11.9576 82.4438 11.4524 82.8164 11.0799C83.1889 10.7073 83.6941 10.4978 84.2209 10.4973H88.5856C89.1134 10.4978 89.6196 10.707 89.9938 11.0793C90.3679 11.4515 90.5797 11.9567 90.5829 12.4845V25.6106C90.5829 27.4631 91.0656 28.9092 92.029 29.9229C92.9925 30.9367 94.2677 31.4757 95.8205 31.4757C97.3732 31.4757 98.6565 30.9548 99.6199 29.9229C100.583 28.8911 101.068 27.453 101.068 25.6106V12.4845C101.069 11.9579 101.278 11.4531 101.65 11.0806C102.022 10.7081 102.527 10.4983 103.053 10.4973H107.404C107.932 10.4978 108.438 10.707 108.812 11.0793C109.186 11.4515 109.398 11.9567 109.401 12.4845Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.887 32.8455V36.8903C134.888 37.4186 134.679 37.9257 134.307 38.3002C133.934 38.6747 133.428 38.886 132.9 38.8876H113.742C113.213 38.8839 112.707 38.6723 112.333 38.2985C111.96 37.9247 111.748 37.4189 111.744 36.8903V33.5695C111.749 32.6177 112.091 31.6983 112.71 30.9749L122.618 19.4961C122.696 19.4098 122.746 19.3026 122.763 19.1878C122.78 19.073 122.763 18.9556 122.714 18.8504C122.668 18.747 122.591 18.6597 122.495 18.5996C122.399 18.5395 122.287 18.5092 122.173 18.5125H113.726C113.197 18.5136 112.69 18.3049 112.316 17.9323C111.941 17.5596 111.73 17.0536 111.728 16.5253V12.4845C111.732 11.9567 111.943 11.4515 112.317 11.0793C112.692 10.707 113.198 10.4978 113.726 10.4973H132.272C132.799 10.4978 133.304 10.7073 133.677 11.0799C134.049 11.4524 134.259 11.9576 134.26 12.4845V15.8012C134.258 16.7533 133.916 17.6735 133.296 18.3959L123.38 29.8847C123.303 29.968 123.254 30.0728 123.239 30.185C123.223 30.2971 123.242 30.4113 123.294 30.5123C123.338 30.6162 123.412 30.7045 123.506 30.7659C123.601 30.8272 123.712 30.8587 123.825 30.8562H132.892C133.154 30.8554 133.413 30.9063 133.655 31.0059C133.897 31.1055 134.117 31.2519 134.302 31.4367C134.488 31.6215 134.635 31.8411 134.735 32.0828C134.835 32.3245 134.887 32.5837 134.887 32.8455Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.379 32.8455V36.8903C160.375 37.4189 160.164 37.9247 159.79 38.2985C159.416 38.6723 158.91 38.8839 158.382 38.8876H139.226C138.697 38.886 138.191 38.6747 137.819 38.3002C137.446 37.9257 137.237 37.4186 137.238 36.8903V33.5695C137.243 32.6177 137.585 31.6983 138.204 30.9749L148.11 19.4961C148.19 19.4128 148.242 19.3068 148.259 19.1926C148.277 19.0784 148.258 18.9617 148.206 18.8585C148.161 18.753 148.086 18.6636 147.989 18.6019C147.893 18.5402 147.78 18.509 147.665 18.5125H139.218C138.956 18.513 138.698 18.462 138.456 18.3623C138.215 18.2626 137.996 18.1163 137.811 17.9317C137.627 17.747 137.48 17.5277 137.381 17.2864C137.281 17.0451 137.23 16.7864 137.23 16.5253V12.4845C137.231 11.9576 137.44 11.4524 137.813 11.0799C138.186 10.7073 138.691 10.4978 139.218 10.4973H157.756C158.284 10.4978 158.79 10.707 159.164 11.0793C159.539 11.4515 159.75 11.9567 159.754 12.4845V15.8012C159.751 16.7535 159.409 17.6737 158.788 18.3959L148.025 30.8663H158.374C158.902 30.8647 159.409 31.0718 159.784 31.4426C160.16 31.8134 160.374 32.3177 160.379 32.8455Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4092 18.5306C18.5257 18.5306 22.6735 14.3829 22.6735 9.26633C22.6735 4.14979 18.5257 0.00201416 13.4092 0.00201416C8.29263 0.00201416 4.14486 4.14979 4.14486 9.26633C4.14486 14.3829 8.29263 18.5306 13.4092 18.5306Z",
    fill: "#F96500"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7368 8.98476C42.7755 10.2477 42.5554 11.5052 42.0901 12.68C41.6248 13.8547 40.9241 14.9219 40.0311 15.8158C39.1381 16.7097 38.0717 17.4115 36.8975 17.8781C35.7232 18.3446 34.4659 18.566 33.203 18.5286C28.1746 18.3838 24.2122 14.1459 24.2122 9.10946V1.85449C24.2122 1.61054 24.2604 1.369 24.354 1.14372C24.4476 0.918443 24.5847 0.713872 24.7576 0.541749C24.9305 0.369627 25.1356 0.233344 25.3613 0.140724C25.587 0.0481033 25.8287 0.000972146 26.0727 0.00203163H33.3136C38.354 0.00203163 42.5879 3.95435 42.7368 8.98476Z",
    fill: "#8F50EA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9376 19.828C21.4366 19.8285 21.9149 20.0271 22.2676 20.3801C22.6202 20.7331 22.8183 21.2117 22.8183 21.7106V29.2472C22.8163 31.1074 22.263 32.9252 21.2282 34.471C20.1935 36.0169 18.7237 37.2213 17.0047 37.9321C15.2857 38.643 13.3946 38.8284 11.5703 38.4648C9.74599 38.1013 8.07037 37.2052 6.75516 35.8897C5.43996 34.5742 4.54419 32.8984 4.18104 31.074C3.8179 29.2496 4.00367 27.3585 4.71488 25.6397C5.4261 23.9208 6.63085 22.4513 8.17689 21.4169C9.72294 20.3825 11.5409 19.8296 13.4011 19.828H20.9376Z",
    fill: "#FFD110"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9299 28.871C42.9791 30.1304 42.7737 31.3867 42.3258 32.5647C41.8778 33.7427 41.1967 34.8182 40.3232 35.7266C39.4497 36.6351 38.4017 37.3578 37.2422 37.8516C36.0826 38.3453 34.8353 38.5999 33.575 38.6H26.0848C25.5881 38.6 25.1118 38.4027 24.7606 38.0515C24.4095 37.7003 24.2122 37.224 24.2122 36.7274V29.2472C24.2178 26.7994 25.1817 24.4512 26.8976 22.7054C28.6134 20.9597 30.9446 19.9554 33.3919 19.9075C35.8393 19.8596 38.208 20.7721 39.9908 22.4494C41.7735 24.1267 42.8286 26.4354 42.9299 28.8811V28.871Z",
    fill: "#3923D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1923",
    x: 0.144861,
    y: 0.00201416,
    width: 26.5286,
    height: 26.5286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1923"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1923",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1923",
    x: 20.2122,
    y: 0.00201416,
    width: 26.5289,
    height: 26.5307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1923"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1923",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1923",
    x: 0,
    y: 19.828,
    width: 26.8183,
    height: 26.8182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1923"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1923",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1923",
    x: 20.2122,
    y: 19.9057,
    width: 26.7249,
    height: 26.6943,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1923"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1923",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.276629c29dbeec98ddb46d7dd952a3cb.svg";
export { ForwardRef as ReactComponent };